module.exports = __webpack_public_path__ + "img/hl-q-icon.bb43c7f5.png";